/* import __COLOCATED_TEMPLATE__ from './security-models-data-sharing.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */

import templateOnlyComponent from '@ember/component/template-only';
import type ModelTrainingConsentOptOutRequest from 'embercom/models/model-training-consent-opt-out-request';

interface SecurityModelsDataSharingArgs {
  dataSharingOptOut?: ModelTrainingConsentOptOutRequest;
}

const SecurityModelsDataSharing = templateOnlyComponent<SecurityModelsDataSharingArgs>();

export default SecurityModelsDataSharing;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::SecurityModelsDataSharing': typeof SecurityModelsDataSharing;
    'new-settings/workspace/security-models-data-sharing': typeof SecurityModelsDataSharing;
  }
}
